/* Accueil ZenSpire (mission 490271) : lecteur vidéo sur place. La vignette est un bouton ; au clic elle est remplacée par le lecteur,
   YouTube sans cookie (iframe créée au clic) ou fichier de la boutique (balise <video> écrite dans un <template>, donc inerte avant le clic).
   Rien n'est chargé avec la page. */

class ZsVideoPlace extends HTMLElement {
  connectedCallback() {
    this.addEventListener('click', this.#clic);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.#clic);
  }

  #clic = (ev) => {
    if (!(ev.target instanceof Element) || !ev.target.closest('[data-zs-lancer]')) return;

    let lecteur = null;
    const youtube = this.dataset.youtube;
    if (youtube) {
      lecteur = document.createElement('iframe');
      lecteur.src = `https://www.youtube-nocookie.com/embed/${encodeURIComponent(youtube)}?autoplay=1&rel=0&playsinline=1`;
      lecteur.title = this.dataset.titre || 'Vidéo ZenSpire';
      lecteur.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
      lecteur.allowFullscreen = true;
      lecteur.referrerPolicy = 'strict-origin-when-cross-origin';
    } else {
      lecteur = this.querySelector('template')?.content.firstElementChild?.cloneNode(true) ?? null;
    }
    if (!lecteur) return;

    // la vidéo reprend son propre format (une vignette en 3:2 devant une vidéo en 16:9, par exemple)
    if (this.dataset.ratio) this.style.setProperty('--zs-vp-ratio', this.dataset.ratio);
    this.replaceChildren(lecteur);
    lecteur.setAttribute('tabindex', '-1');
    lecteur.focus({ preventScroll: true });
    if (lecteur instanceof HTMLVideoElement) lecteur.play().catch(() => {});
  };
}

if (!customElements.get('zs-video-place')) customElements.define('zs-video-place', ZsVideoPlace);
